import {ValidationAction, ValidationCondition, ValidationTrigger} from "../../modules/validations/@const";
import {ValidationJson} from "./@types";
import Condition from "./condition/condition";
import formatDate from "../../gd/format/date";
import DatetimeUtils from "../../gd/utils/datetime-utils";
import moment from "moment";


export default class Validation {

    public id           : string
    public trigger      : ValidationTrigger
    public condition    : Condition
    public action       : ValidationAction
    public isSystem     : boolean   // indicates if it's system or user created

    constructor(info:ValidationJson) {

        this.id         = info.id;

        this.trigger    = info.trigger;
        this.condition  = new Condition(info.condition)

        this.action     = info.action
        this.isSystem   = !!info.isSystem

    }

    toJSON() {
        return {
            id          : this.id,
            trigger     : this.trigger,
            condition   : this.condition.toJSON(),
            action      : this.action,
        }
    }

}